import React, { useState } from "react"
import styled from "styled-components"

import { H5 } from "../general/GeneralStyles"
import ProductModal from "./ProductModal"

// const H5 = styled.h5``

const ProductContainer = styled.div`
  position: relative;
  width: auto;
  display: inline-block;
  cursor: pointer;
  padding: 50px;
  /* background: #fff; */
  border-right: solid 2px #f0efea;
  border-bottom: solid 2px #f0efea;

  &:hover ${H5} {
    color: #c43745;
  }

  ${H5} {
    font-family: ${props => props.theme.primaryFont};
    font-size: 16px;
    margin-top: 5px;
    cursor: pointer;

    @media (max-width: ${props => props.theme.smallBreakpoint}) {
      font-size: 12px;
    }
  }

  @media (max-width: ${props => props.theme.largeBreakpoint}) {
    padding: 25px;
    text-align: center;
  }

  @media (max-width: ${props =>
      props.theme.mediumBreakpoint}) and (min-width: ${props =>
      props.theme.smallBreakpoint}) {
    padding: 50px;
  }
  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    padding: 5px;
    text-align: center;
  }
`

const Points = styled.div`
  position: absolute;
  right: 40px;
  top: 40px;
  z-index: 10;

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    right: 10px;
    top: 10px;
  }

  &::before {
    background: url("/images/bg/red_smudge.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    content: "";
    height: 89px;
    width: 97px;
    position: absolute;
    z-index: -1;
    left: -20px;
    top: -20px;

    @media (max-width: ${props => props.theme.smallBreakpoint}) {
      height: 60px;
      width: 60px;
      left: -10px;
      top: -5px;
    }
  }

  span {
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    display: block;
  }

  span:nth-child(1) {
    font-family: ${props => props.theme.secondaryFont};
    font-size: 24px;
    line-height: 26px;

    @media (max-width: ${props => props.theme.smallBreakpoint}) {
      font-size: 20px;
      line-height: 20px;
      display: inline-block;
      padding-top: 2px;
    }
  }

  span:nth-child(2) {
    font-family: ${props => props.theme.secondaryFont};
    font-size: 18px;
    line-height: 20px;

    @media (max-width: ${props => props.theme.smallBreakpoint}) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`

const ProductImg = styled.img`
  height: 300px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
`;

const Product = props => {
  const [modalActive, setModalActive] = useState(false)
  return (
    <>
      <ProductContainer
        onClick={() => {
          setModalActive(true)
        }}
      >
        <Points>
          <span>{props.product.points}</span>
          <span>Points</span>
        </Points>
        <ProductImg
          src={
            props.product.img_url ||
            "http://prang.flywheelsites.com/wp-content/uploads/2019/04/33FF1E9E-1E4F-395D-A3A19C64CE47B038-300x300.jpg"
          }
          alt=""
        />
        <H5>{props.product.name}</H5>
      </ProductContainer>
      {modalActive ? (
        <ProductModal onClick={setModalActive} product={props.product} />
      ) : null}
    </>
  )
}

export default Product
